// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Array from "rescript/lib/es6/belt_Array.js";

var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_@$*";

function encode(number, pad) {
  var value = number / 64 | 0;
  var curr = number % 64;
  var encoded = chars.charAt(curr);
  while(value > 0) {
    curr = value % 64;
    value = value / 64 | 0;
    encoded = chars.charAt(curr) + encoded;
  };
  return encoded.padStart(pad, "A");
}

function encode1(number) {
  return chars.charAt(number);
}

function decode(encoded) {
  return Belt_Array.reduce(Belt_Array.map(encoded.split(""), (function (c) {
                    return chars.indexOf(c);
                  })), 0, (function (acc, v) {
                return (acc << 6) + v | 0;
              }));
}

function encode2(number) {
  if (number >= 64) {
    return "$" + chars.charAt(number - 64 | 0);
  } else {
    return chars.charAt(number);
  }
}

function decode2(encoded) {
  var c1 = encoded.charAt(0);
  if (c1 !== "$") {
    return [
            chars.indexOf(c1),
            1
          ];
  }
  var c2 = encoded.charAt(1);
  return [
          64 + chars.indexOf(c2) | 0,
          2
        ];
}

export {
  chars ,
  encode ,
  encode1 ,
  decode ,
  encode2 ,
  decode2 ,
  
}
/* No side effect */
